import {
    generate
} from '../../../core/js/utils/componentUtils';

const className = 'has-mouse-click-focus-disabled';

export function attachEvents(store) {

    $(document).on(this.scopedEvent('touchend click'), this.target, (e) => {
        addFocusClass(e);
    });
}

function removeFocusClass(el) {

    const removeFocusEl = el.currentTarget || el;

    removeFocusEl.classList.remove(className);

     // Don't listen for these events in the IDLE state
    removeFocusEl.removeEventListener('blur', removeFocusClass);

     // eslint-disable-next-line no-use-before-define
    removeFocusEl.addEventListener('mousedown', addFocusClass);
}

function addFocusClass(e) {

    const removeFocusEl = e.currentTarget;

     // Add the class
    removeFocusEl.classList.add(className);

    // Throw this behind rAF, as we saw some odd race conditions where blur would
    // immediately fire and remove the class
    requestAnimationFrame(() => {
        removeFocusEl.addEventListener('blur', removeFocusClass, { once: true });
    });
}

/**
 *
 * Users of this class can overwrite the tagBaseSlug
 *  to use a different base slug on the tag
 *
 * @param {object} store The redux store
 * @param {object} overrides Params to override componentUtils defaults
 * @returns {*} Component generator
 */
export function init(store, overrides = {}) {
    const config = {
        name: 'focusComponent',
        target: '.has-mouse-click-focus-disabled',
        attachEvents: attachEvents
    };

    return generate(config, store, overrides);
}
